import * as React from 'react';

const styles = (
    visible: boolean,
    height: number,
    transitionDuration: string
): React.CSSProperties => {
    return {
        height: visible ? height : '0px',
        opacity: visible ? '100%' : '0%',
        transitionProperty: 'height, opacity',
        transitionDuration: `${transitionDuration}, 0s`,
    };
};

export interface TransitionOutItemProps {
    onHeightTransitionEnd?: (event: React.TransitionEvent<unknown>) => void;
    height: number;
    transitionDuration?: string;
}

/**
 * This component simply takes up space before animating away
 */
export const TransitionOutItem = (props: TransitionOutItemProps): JSX.Element => {
    const { onHeightTransitionEnd, height, transitionDuration = '200ms' } = props;
    const [visible, setVisible] = React.useState(true);

    if (visible) {
        requestAnimationFrame(() => setVisible(false));
    }

    const onTransitionEndCallback = React.useCallback(
        (event: React.TransitionEvent<HTMLDivElement>): void => {
            if (event.propertyName === 'height') {
                onHeightTransitionEnd?.(event);
            }
        },
        [onHeightTransitionEnd]
    );

    return (
        <div
            style={styles(visible, height, transitionDuration)}
            onTransitionEnd={onTransitionEndCallback}
        />
    );
};

TransitionOutItem.displayName = 'TransitionOutItem';
